module.exports = "<div class=locationDetailsInventory ng-cloak layout=row> <div ng-if=\"c.inventory && c.inventory.length === 0\" flex layout=row> <span flex=30></span> <div layout=row flex> <div class=\"circle md-whiteframe-z2\" layout=row layout-align=\"center center\"> <h3 class=white-text>Ingen beholdningsinformasjon</h3> </div> </div> </div> <md-card ng-show=\"c.tableDefinition.promise || c.inventory.length > 0\" flex> <rkc-table table-definition=c.tableDefinition table-content=c.inventory></rkc-table> </md-card> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/main/views/locations/locationDetails/locationDetailsInventory/locationDetailsInventory.html
 ** module id = 511
 ** module chunks = 0
 **/